export default __webpack_public_path__ + "static/webRotator/svg/4509419e016340bb81b5dc69e8fab759.svg";